var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BoxedLayout',[_c('Logo'),_c('router-view',{staticClass:"router-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }